
import { Component, Prop, Vue } from 'vue-property-decorator';
import Media from '@/ui-components/Media/Media.vue';
import CampaignInfo from '@/ui-components/CampaignInfo/CampaignInfo.vue';
import IButton from '@/ui-components/IButton/IButton.vue';
import ITextArea from '@/ui-components/ITextArea/ITextArea.vue';
import IDialog from '@/ui-components/IDialog/IDialog.vue';
import { PendingCampaign } from '@/types/campaigns';
import { RejectCampaign } from '@/store/modules/incoming-campaigns-module/types';
import namespaces from '@/store/namespaces';
import { Action } from 'vuex-class';
import { ShowSnackbar } from '@/types/snackbar';
import { Dialog } from '@/types/misc';

@Component({
  components: { Media, IButton, ITextArea, IDialog, CampaignInfo },
})
export default class CampaignRejectDialog extends Vue implements Dialog {
  @Prop({ type: Object, default: () => ({}) })
  public campaign!: PendingCampaign;

  public loading = false;
  public reason = '';

  @Action('rejectCampaign', { namespace: namespaces.IncomingCampaignsModule })
  public rejectCampaign!: RejectCampaign;

  @Action('showSnackbar', { namespace: namespaces.UiModule })
  public showSnackbar!: ShowSnackbar;

  public get campaignLocations() {
    return this.campaign.locations.map(({ NAME }) => NAME).join(', ');
  }

  public async rejectStoreCampaign() {
    try {
      this.loading = true;
      const { campaignRequest } = this.campaign;
      await this.rejectCampaign({ campaignRequest, rejectionReason: this.reason});
      const text = `${this.$t('you_rejected_new_campaign')} "${ this.campaign.name }" ${ this.$t('_at') } "${ this.campaignLocations }"`;
      this.showSnackbar({
        color: 'info',
        text,
      });
      this.close();
    } catch (error) {
      this.loading = false;
      this.showSnackbar({
        color: 'danger',
        text: this.$t('error_rejecting_campaign') as string,
      });
    }
    finally {
      this.loading = false;
      this.reason=''
    }
  }

  public isOpen = false;

  public open() {
    this.isOpen = true;
  }

  public close() {
    this.isOpen = false;
  }
}
